import { render, staticRenderFns } from "./MessageTemplateForm.vue?vue&type=template&id=0163f79e&"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateForm.vue?vue&type=style&index=0&id=0163f79e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports